import { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { getMainTheme } from "../../../../core/utils/theme";
import { CFlex, Column, DeleteIcon, Flex, Row } from "../../../../styles/CommonStyles";
import Text from "../../../../core/utils/Text";
import { EditIcon } from "../../../../styles/main/setting";
import ModalLayout from "../../../layout/main/ModalLayout";
import SuggestionModal from "./SuggestionModal";

// Define headers and column structure
const suggestionAttributes = {
  headers: [
    { title: "pair" },
    { title: "assistant" },
    { title: "title" },
    { title: "subtitle" },
    { title: "created_at" },
    { title: "action" },
  ],
  cs: "1fr 1fr 1fr 1fr 0.8fr 0.5fr",
};

const SuggestionListing = ({ suggestions, isLoading }) => {
  const { headers, cs } = suggestionAttributes;

  const initial = { show: false, suggestion: null, type: "edit" };
  const [suggestionModal, setSuggestionModal] = useState(initial);

  const closeSuggestionModal = () => setSuggestionModal(initial);
  const openSuggestionModal = (suggestion, type = "edit") =>
    setSuggestionModal({ show: true, suggestion, type });

  return (
    <>
      <CFlex fw>
        {isLoading ? (
          <Flex height={"300px"}>
            <ScaleLoader color={getMainTheme().active} />
          </Flex>
        ) : (
          <>
            <Row cs={cs} header={1}>
              {headers.map((h) => (
                <Column key={h.title}>
                  <Text tid={h.title} />
                </Column>
              ))}
            </Row>

            {suggestions?.data?.map((suggestion, idx) => (
              <Row
                cs={cs}
                index={idx}
                key={suggestion.id}
                noHover={1}
              >
                {/* Pair */}
                <Column>
                  <Flex direction="column">
                    <div>{suggestion.pair?.symbol}</div>
                    <small style={{ opacity: 0.6 }}>
                      {suggestion.pair?.market_type}
                    </small>
                  </Flex>
                </Column>

                {/* Assistant */}
                <Column>
                  <Flex direction="column">
                    <div>{suggestion.assistant?.type}</div>
                  </Flex>
                </Column>

                {/* Title */}
                <Column>{suggestion.title}</Column>

                {/* Subtitle */}
                <Column>{suggestion.subtitle}</Column>

                {/* Created At */}
                <Column>
                  {new Date(suggestion.created_at).toLocaleDateString()}
                </Column>

                {/* Actions */}
                <Flex gap="8px">
                  <EditIcon
                    size={22}
                    onClick={() => openSuggestionModal(suggestion, "edit")}
                  />
                  <DeleteIcon
                    size={22}
                    color="#d33"
                    onClick={() => openSuggestionModal(suggestion, "delete")}
                  />
                </Flex>
              </Row>
            ))}
          </>
        )}
      </CFlex>

      <ModalLayout
        width={"620px"}
        open={suggestionModal.show}
        onClose={closeSuggestionModal}
      >
        <SuggestionModal
          onSuccess={closeSuggestionModal}
          _suggestion={suggestionModal.suggestion}
          existingSuggestions={suggestions}
          type={suggestionModal.type}
        />
      </ModalLayout>
    </>
  );
};

export default SuggestionListing;